<template>
  <div>
    <div class="pad-bot10 f16 width98 textalign-left">甘特图</div>
    <div class="margin-auto flex pad-top10 cursorpointer">
      <div class="headbut" @click="collapase()">收起</div>
      <div class="headbut" @click="expand()">展开</div>
      <!-- <div class="headbut">Undo</div>
      <div class="headbut">Redo</div> -->
      <div class="headbut" @click="refresh()">刷新</div>
      <!-- <div class="headbut">Critical</div> -->
      <div class="headbut" @click="zoom_in()">放大</div>
      <div class="headbut" @click="zoom_out()">缩小</div>
      <div class="headbut" @click="zoom_day()">自适应</div>
      <div class="headbut" @click="allexpand()">全屏</div>
    </div>
    <div
      id="gantt_here"
      style="width: 100%; height: 400px"
      class="margin-auto"
    ></div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import gantt from "dhtmlx-gantt"; // 引入模块
import "@/assets/css/dhtmlxgantt.css";
import { pipoList } from "@/api/Center/Center.api";
import {
  //   获取任务
  projecttaskindex,
  //保存-添加
  projecttasksave,
  // 双击删除任务
  projecttaskdel,
  //创建连接
  projecttasklinksave,
  //删除连接
  projecttasklinkdel,
  //根据项目id获取项目
  projecttaskfind,
  //更新
  projecttaskupdate,
} from "@/api/loader/loder.api";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      page: [],
      tasks: {
        data: [],
        staffs: [],
        links: [],
      },
      centerNums: "",
      creatid: "",
    };
  },
  methods: {
    zoom_in() {
      gantt.ext.zoom.zoomIn();
    },
    zoom_out() {
      gantt.ext.zoom.zoomOut();
    },
    zoom_day() {
      gantt.ext.zoom.setLevel("day");
    },
    collapase() {
      gantt.config.open_split_tasks = true;
    },
    expand() {
      gantt.config.open_split_tasks = false;
    },
    refresh() {
      gantt.refreshData();
    },
    reload() {
      // gantt.clearAll(); // 从甘特图中删除所有任务和其他元素（包括标记）
      gantt.parse(this.tasks); // 数据解析
      gantt.render(); // 呈现整个甘特图
    },
    allexpand() {
      gantt.expand();
    },
  },

  created() {
    this.centerNums = window.sessionStorage.getItem("centerNums");
    // 获取任务列表
    projecttaskindex({
      page: 1,
      limit: 30,
      project_id: this.centerNums,
    }).then((res) => {
      if (res.data.code == 200) {
        res.data.data.data.forEach((i) => {
          // 任务
          let proindex = {};
          proindex.id = i.id;
          proindex.start_date = i.start_date;
          proindex.duration = i.duration;
          proindex.text = i.title;
          proindex.progress = i.progress;
          proindex.parent = i.parent;
          proindex.open = true;
          // proindex.end_date = i.end_date;
          proindex.priority = i.priority;
          proindex.type = i.type;
          proindex.owner_id = i.user_id;
          this.tasks.data.push(proindex);

          let alllink = {};
          alllink.id = i.id;
          alllink.source = i.source;
          alllink.target = i.target;
          alllink.type = i.type;
          this.tasks.links.push(alllink);
        });

        this.reload();
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    gantt.i18n.setLocale("cn");

    gantt.staffs;
    gantt.config.date_format = "%Y-%m-%d %H:%i:%s";

    gantt.serverList("priority", [
      { key: 1, label: "高" },
      { key: 2, label: "普通" },
      { key: 3, label: "低" },
    ]);

    // end test data
    gantt.config.grid_width = 620;
    gantt.config.grid_resize = true;
    gantt.config.open_tree_initially = true;

    var labels = gantt.locale.labels;
    labels.column_priority = labels.section_priority = "优先";
    labels.column_owner = labels.section_owner = "责任人";
    labels.column_remark = labels.section_remark = "备注";

    function byId(list, id) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].key == id) return list[i].label || "";
      }
      return "";
    }
    //获取人员
    let staffs = [];
    pipoList({
      dev_project_id: window.sessionStorage.getItem("centerNums"),
    }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data;
        console.log(this.page);
        this.page.forEach((i) => {
          let itemstaff = {};
          itemstaff.key = i.user_id;
          itemstaff.label = i.realname;
          itemstaff.backgroundColor = i.color;
          itemstaff.textColor = "#fff";
          staffs.push(itemstaff);
        });

        this.reload();
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    gantt.config.columns = [
      {
        name: "owner",
        width: 80,
        align: "center",
        template: function (item) {
          return byId(staffs, item.owner_id);
        },
      },
      { name: "text", label: "任务名称", tree: true, width: "*" },
      {
        name: "priority",
        width: 40,
        align: "center",
        template: function (item) {
          return byId(gantt.serverList("priority"), item.priority);
        },
      },
      { name: "duration", align: "center", width: 80, resize: true },
      { name: "add", width: 40 },
    ];
    gantt.locale.labels["section_progress"] = "进度";
    gantt.config.lightbox.sections = [
      {
        name: "description",
        height: 38,
        map_to: "text",
        type: "textarea",
        focus: true,
      },
      {
        name: "priority",
        height: 22,
        map_to: "priority",
        type: "select",
        options: gantt.serverList("priority"),
      },
      {
        name: "owner",
        height: 22,
        map_to: "owner_id",
        type: "select",
        options: staffs,
      },

      {
        name: "time",
        type: "duration",
        map_to: "auto",
        year_range: [2000, 2040],
      },
      {
        name: "progress",
        height: 22,
        label: "进度",
        map_to: "progress",
        type: "select",
        options: [
          { key: "0", label: "未开始" },
          { key: "0.1", label: "10%" },
          { key: "0.2", label: "20%" },
          { key: "0.3", label: "30%" },
          { key: "0.4", label: "40%" },
          { key: "0.5", label: "50%" },
          { key: "0.6", label: "60%" },
          { key: "0.7", label: "70%" },
          { key: "0.8", label: "80%" },
          { key: "0.9", label: "90%" },
          { key: "1", label: "已完成" },
        ],
      },
      {
        name: "remark",
        label: "备注",
        height: 38,
        map_to: "remark",
        type: "textarea",
        focus: true,
      },
    ];
    // 添加任务
    gantt.attachEvent("onBeforeTaskAdd", function (id, item) {
      console.log(id, item);
      // 开始时间
      var date = new Date(item.start_date);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date.getSeconds();
      second = second < 10 ? "0" + second : second;
      let Time = y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
      // j结束时间
      var dates = new Date(item.end_date);
      var yy = dates.getFullYear();
      var mm = dates.getMonth() + 1;
      mm = mm < 10 ? "0" + mm : mm;
      var dd = dates.getDate();
      dd = dd < 10 ? "0" + dd : dd;
      var hh = dates.getHours();
      var minutes = dates.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var seconds = dates.getSeconds();
      seconds = seconds < 10 ? "0" + seconds : seconds;
      let Times =
        yy + "-" + mm + "-" + dd + " " + hh + ":" + minutes + ":" + seconds;
      //any custom logic here
      projecttasksave({
        project_id: window.sessionStorage.getItem("centerNums"),
        title: item.text,
        start_date: Time,
        end_date: Times,
        type: "task",
        progress: item.progress,
        duration: item.duration,
        parent_id: item.parent,
        priority: item.priority,
        user_id: item.owner_id,
        articipants: [item.owner_id],
        participants: item.owner_id, //参与人id,
        remark: item.remark,
        open: 1,
      }).then((res) => {
        // this.creatid = res.data.data.id;
        gantt.changeTaskId(id, res.data.data.id);
        gantt.init("gantt_here");
        if (res.data.code == 200) {
          console.log(1);
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
      return true;
    });

    // 双击删除任务
    gantt.attachEvent("onBeforeTaskDelete", function (id, item) {
      projecttaskdel({ id: id }).then((res) => {
        if (res.data.code == 200) {
          console.log(6);
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
      return true;
    });
    // 点击按钮删除
    gantt.attachEvent("onBeforeLinkDelete", function (id, item) {
      projecttaskdel({ id: id }).then((res) => {
        if (res.data.code == 200) {
          console.log(2);
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
      return true;
    });

    //更新
    gantt.attachEvent("onBeforeTaskUpdate", function (id, new_item) {
      //any custom logic here

      var date = new Date(new_item.start_date);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date.getSeconds();
      second = second < 10 ? "0" + second : second;
      let Time = y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
      //any custom logic here
      projecttaskupdate({
        id: id,
        title: new_item.text,
        start_date: Time,
        type: 1,
        duration: new_item.duration,
        progress: new_item.progress,
        parent_id: new_item.parent,
        priority: new_item.priority,
        user_id: new_item.owner_id,
        participants: new_item.owner_id, //参与人id,
        remark: new_item.remark,
        open: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          console.log(3);
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    });

    //拖动连接
    gantt.attachEvent("onLinkCreated", function (link) {
      // your code here
      projecttasklinksave({
        project_id: window.sessionStorage.getItem("centerNums"),
        type: link.type,
        source: link.source,
        target: link.target,
      }).then((res) => {
        if (res.data.code == 200) {
          console.log(4);
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
      return true;
    });
    // 更改连接
    // gantt.attachEvent("onLinkIdChange", function (id, new_id) {
    //   //any custom logic here
    // });

    // 双击连接
    gantt.attachEvent("onLinkDblClick", function (id, e) {
      //any custom logic here
      projecttasklinkdel({
        project_id: window.sessionStorage.getItem("centerNums"),
        id: id,
      }).then((res) => {
        if (res.data.code == 200) {
          console.log(5);
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
      return true;
    });

    gantt.attachEvent("onTaskMultiSelect", function (id, state, e) {
      // some logic here
    });

    gantt.templates.rightside_text = function (start, end, task) {
      return byId(gantt.serverList("staff"), task.owner_id);
    };

    gantt.templates.grid_row_class =
      gantt.templates.task_row_class =
      gantt.templates.task_class =
        function (start, end, task) {
          var css = [];
          if (task.$virtual || task.type == gantt.config.types.project)
            css.push("summary-bar");

          if (task.owner_id) {
            css.push("gantt_resource_task gantt_resource_" + task.owner_id);
          }

          return css.join(" ");
        };

    gantt.attachEvent("onParse", function () {
      var styleId = "dynamicGanttStyles";
      var element = document.getElementById(styleId);
      if (!element) {
        element = document.createElement("style");
        element.id = styleId;
        document.querySelector("head").appendChild(element);
      }
      var html = [];
      var resources = staffs;
      resources.forEach(function (r) {
        html.push(
          ".gantt_task_line.gantt_resource_" +
            r.key +
            "{" +
            "background-color:" +
            r.backgroundColor +
            "; " +
            "color:" +
            r.textColor +
            ";" +
            "}"
        );
        html.push(
          ".gantt_row.gantt_resource_" +
            r.key +
            " .gantt_cell:nth-child(1) .gantt_tree_content{" +
            "background-color:" +
            r.backgroundColor +
            "; " +
            "color:" +
            r.textColor +
            ";" +
            "}"
        );
      });
      element.innerHTML = html.join("");
    });
    gantt.config.order_branch = true;
    gantt.config.order_branch_free = true;
    // 全屏
    gantt.plugins({
      fullscreen: true,
    });

    var zoomConfig = {
      levels: [
        {
          name: "day",
          scale_height: 27,
          min_column_width: 80,
          scales: [{ unit: "day", step: 1, format: "%Y-%m-%d" }],
        },
        {
          name: "week",
          scale_height: 50,
          min_column_width: 50,
          scales: [
            {
              unit: "week",
              step: 1,
              format: function (date) {
                var dateToStr = gantt.date.date_to_str("%d %M");
                var endDate = gantt.date.add(date, 6, "day");
                var weekNum = gantt.date.date_to_str("%W")(date);
                return (
                  "#" +
                  weekNum +
                  ", " +
                  dateToStr(date) +
                  " - " +
                  dateToStr(endDate)
                );
              },
            },
            { unit: "day", step: 1, format: "%j %D" },
          ],
        },
        {
          name: "month",
          scale_height: 50,
          min_column_width: 120,
          scales: [
            { unit: "month", format: "%F, %Y" },
            { unit: "week", format: "Week #%W" },
          ],
        },
        {
          name: "quarter",
          height: 50,
          min_column_width: 90,
          scales: [
            { unit: "month", step: 1, format: "%M" },
            {
              unit: "quarter",
              step: 1,
              format: function (date) {
                var dateToStr = gantt.date.date_to_str("%M");
                var endDate = gantt.date.add(
                  gantt.date.add(date, 3, "month"),
                  -1,
                  "day"
                );
                return dateToStr(date) + " - " + dateToStr(endDate);
              },
            },
          ],
        },
        {
          name: "year",
          scale_height: 50,
          min_column_width: 30,
          scales: [{ unit: "year", step: 1, format: "%Y" }],
        },
      ],
    };

    gantt.ext.zoom.init(zoomConfig);
    gantt.config.work_time = true;

    // 初始化
    gantt.init("gantt_here");
    // 数据解析
    gantt.parse(this.tasks);
  },
};
</script>
<style scoped>
.gantt_task_line.gantt_project {
  color: white;
}

.gantt_side_content {
  color: #333;
}

.summary-bar {
  font-weight: bold;
}

.gantt_resource_task .gantt_task_content {
  color: inherit;
}

.gantt_resource_task .gantt_task_progress {
  background-color: rgba(33, 33, 33, 0.3);
}

.gantt_cell:nth-child(1) .gantt_tree_content {
  border-radius: 16px;
  width: 100%;
  /* height: 80%; */
  margin: 5% 0;
  line-height: 230%;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>
